<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">希望年収</label>
      </div>
      <div class="col-12 pe-0">
        <Field
          v-slot="{ field, errors }"
          v-model="optionalInformationStore.desired_annual_income"
          name="desired_annual_income"
        >
          <textarea
            class="input-primary form-control bg-silver-primary rounded-1 size-14 border-0"
            rows="5"
            placeholder="年収700万円以上を希望します。&#10;年収500万円～700万円程度を希望します。&#10;年収450万円以上であれば検討します。"
            :class="{ 'is-invalid': !!errors.length }"
            v-bind="field"
          >
            ></textarea
          >
          <div class="d-md-flex d-block justify-content-md-between align-items-md-center p-2">
            <ErrorMessage name="desired_annual_income" class="invalid-feedback m-0 d-block" />
            <div
              class="note size-10 ms-auto text-end w-50"
              :class="
                optionalInformationStore.desired_annual_income?.length > 300
                  ? 'text-danger'
                  : 'text-black-50'
              "
            >
              {{
                optionalInformationStore.desired_annual_income?.length || 0
              }}/300（最大文字数300文字）
            </div>
          </div>
        </Field>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';

const optionalInformationStore = useOptionalInformationStore();
</script>
